import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { Button } from '../button/button';
import { HideExamplesButtonProps } from './types';

export const HideExamplesButton = ({
  isHidden,
  clickHandler,
}: HideExamplesButtonProps) => {
  return (
    <Button variant="outline" size="sm" onClick={clickHandler}>
      {isHidden ? <EyeIcon /> : <EyeOffIcon />}
      {isHidden ? 'Show' : 'Hide'} examples
    </Button>
  );
};
